import ChatIcon from '@mui/icons-material/Chat'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'
import { SvgIconProps } from '@mui/material'
import { ForwardedRef, forwardRef } from 'react'

import { EChannelKeys } from '~/features/inbox/models'

type TProps = {
  channel: EChannelKeys
} & SvgIconProps

const ChannelIcon = forwardRef(
  // todo: is ref actually needed? maybe remove it.
  ({ channel, ...props }: TProps, ref: ForwardedRef<SVGSVGElement>) => {
    switch (channel) {
      case EChannelKeys.chat:
        return (
          <SmartToyOutlinedIcon
            ref={ref as ForwardedRef<SVGSVGElement>}
            {...props}
          />
        )
      case EChannelKeys.email:
        return <EmailIcon ref={ref as ForwardedRef<SVGSVGElement>} {...props} />
      case EChannelKeys.phone:
        return <PhoneIcon ref={ref as ForwardedRef<SVGSVGElement>} {...props} />
      case EChannelKeys.text:
        return <ChatIcon ref={ref as ForwardedRef<SVGSVGElement>} {...props} />
      default:
        throw new Error(`Unknown channel: ${channel}`)
    }
  },
)

export default ChannelIcon
